import React, { useState, useEffect, useRef } from 'react';
import api from '../../api/api';
import { useNavigate } from 'react-router-dom';
import ImageIcon from '@mui/icons-material/Image';
import SendIcon from '@mui/icons-material/Send';
import { jwtDecode } from 'jwt-decode'; 
import chatWallpaper from "./chatbackground.jpg";

import {
  Avatar,
  Box,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  TextField,
  Button,
  Typography,
  Badge,
  InputAdornment,
  Drawer,
  Tooltip,
} from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import SearchIcon from '@mui/icons-material/Search';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';

const ChatApp = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [message, setMessage] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [image, setImage] = useState(null);
  const [socket, setSocket] = useState(null);
  const typingTimeout = useRef(null);
  const chatEndRef = useRef(null);

  // const token = localStorage.getItem('access');
  // const navigate = useNavigate();

  // let currentUserId = null;
  // let currentUserRole = null;

  // try {
  //   const decoded = jwtDecode(token);
  //   currentUserId = decoded.user_id;
  //   currentUserRole = decoded.user_type;
  // } catch (error) {
  //   console.error('Invalid token');
  // }

const token = localStorage.getItem("access");
const navigate = useNavigate();

let currentUserId = null;
let currentUserRole = null;

try {
  const decoded = jwtDecode(token);

  const savedUser = JSON.parse(
    localStorage.getItem("user") || "{}"
  );

  currentUserId =
    decoded.user_id ||
    decoded.user ||
    savedUser.id;

  currentUserRole = (
    decoded.user_type ||
    decoded.role ||
    savedUser.user_type ||
    savedUser.role ||
    ""
  )
    .toLowerCase()
    .trim()
    .replace(/_/g, " ");

  console.log("Decoded Token:", decoded);
  console.log("Saved User:", savedUser);
  console.log("Current User ID:", currentUserId);
  console.log("Current User Role:", currentUserRole);

} catch (error) {
  console.error("Unable to determine authenticated user:", error);
}

  // const handleRedirectToDashboard = () => {
  //   if (!currentUserRole) return;
  //   switch (currentUserRole) {
  //     case 'admin': 
  //       navigate('/newAdminDashboard');
  //       break;
  //     case 'teacher':
  //       navigate('/teacher-dashboard');
  //       break;
  //     case 'student':
  //       navigate('/student-dashboard');
  //       break;
  //     case 'parent':
  //       navigate('/parentsDashboard');
  //       break;
  //     case 'registry':
  //       navigate('/registerDashboard');
  //       break;
  //     case 'business manager':
  //       navigate('/businessManagerDashboard');
  //       break;
  //     case 'vpi':
  //       navigate('/vpiDashboard');
  //       break;
  //     case 'vpa':
  //       navigate('/vpaDashboard');
  //       break;
  //     case 'dean':
  //       navigate('/deanDashboard');
  //       break;
  //     case 'it personel':
  //       navigate('/iTPersonalDashboard');
  //       break;
  //     default:
  //       navigate('/');
  //   }
  // };

const handleRedirectToDashboard = () => {
  if (!currentUserRole) {
    console.error(
      "Cannot redirect: currentUserRole is missing."
    );

    navigate("/login");
    return;
  }

  switch (currentUserRole) {

    case "admin":
      navigate("/newAdminDashboard");
      break;

    case "teacher":
      navigate("/teacher-dashboard");
      break;

    case "student":
      navigate("/student-dashboard");
      break;

    case "parent":
      navigate("/parentsDashboard");
      break;

    case "registry":
      navigate("/registerDashboard");
      break;

    case "business manager":
      navigate("/businessManagerDashboard");
      break;

    case "vpi":
      navigate("/vpiDashboard");
      break;

    case "vpa":
      navigate("/vpaDashboard");
      break;

    case "dean":
      navigate("/deanDashboard");
      break;

    case "it personnel":
    case "it personel":
      navigate("/iTPersonalDashboard");
      break;

    default:
      console.error(
        "Unknown user role:",
        currentUserRole
      );

      navigate("/");
  }
};

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await api.get('/api/users/chat/userslist/');
        setUsers(response.data);
        setFilteredUsers(response.data);
      } catch (error) {
        console.error('Failed to fetch users:', error);
      }
    };

    fetchUsers();
    const interval = setInterval(fetchUsers, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchChatHistory = (userId) => {
    api
      .get(`/api/users/chats/${userId}/chat_history/`)
      .then((res) => setChatHistory(res.data))
      .catch((err) => console.error('Error fetching chat history:', err));
  };

  useEffect(() => {
    if (!selectedUser || !selectedUser.id) return;

    if (socket && (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING)) {
      socket.close();
    }

    const wsUrl = `wss://messiahmissioninstitute.online/ws/chat/${selectedUser.id}/?token=${token}`;
    const ws = new WebSocket(wsUrl);

    ws.onopen = () => console.log('WebSocket connected to:', selectedUser.username);

    ws.onmessage = (e) => {
      const data = JSON.parse(e.data);

      const incomingMessage = {
        id: data.id || Date.now(),
        sender: data.sender_id || data.sender,
        receiver: data.receiver_id || data.receiver,
        message: data.message,
        image: data.image || null,
        timestamp: data.timestamp,
        sender_profile_image: data.sender_profile_image || null,
      };

      if (
        incomingMessage.sender === selectedUser.id ||
        incomingMessage.receiver === selectedUser.id
      ) {
        setChatHistory((prev) => [...prev, incomingMessage]);
      }
    };

    ws.onerror = (e) => console.error('WebSocket error:', e);
    ws.onclose = (e) => console.log('WebSocket disconnected:', e);

    setSocket(ws);

    fetchChatHistory(selectedUser.id);

    return () => {
      if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING) {
        ws.close();
      }
    };
  }, [selectedUser, token]);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [chatHistory]);

  const handleUserClick = (user) => {
    setSelectedUser(user);
    if (drawerOpen) setDrawerOpen(false);
  };

  const handleSendMessage = () => {
    if (!message.trim() && !image) return;

    if (image) {
      const formData = new FormData();
      formData.append('receiver', selectedUser.id);
      formData.append('message', message);
      formData.append('image', image);

      api
        .post('/api/users/chats/', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('access')}`,
          },
        })
        .then((response) => {
          setMessage('');
          setImage(null);
          fetchChatHistory(selectedUser.id);

          const chatData = response.data;

          if (socket && socket.readyState === WebSocket.OPEN) {
            socket.send(
              JSON.stringify({
                receiver: selectedUser.id,
                message: chatData.message,
                image: chatData.image,
                timestamp: chatData.timestamp,
                sender_profile_image: chatData.sender_profile_image,
                sender_id: chatData.sender,
              })
            );
          }
        })
        .catch((err) => {
          console.error('Error sending message:', err);
        });
    } else {
      if (socket && socket.readyState === WebSocket.OPEN) {
        socket.send(
          JSON.stringify({
            receiver: selectedUser.id,
            message: message,
          })
        );
        setMessage('');
      } else {
        api
          .post('/api/users/chats/', {
            receiver: selectedUser.id,
            message: message,
          }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('access')}`,
            },
          })
          .then(() => {
            setMessage('');
            fetchChatHistory(selectedUser.id);
          })
          .catch((err) => console.error('Error sending message:', err));
      }
    }
  };

  const handleTyping = () => {
    if (!selectedUser) return;
    setIsTyping(true);
    clearTimeout(typingTimeout.current);
    typingTimeout.current = setTimeout(() => setIsTyping(false), 1500);
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    setFilteredUsers(
      users.filter((user) => user.username.toLowerCase().includes(value))
    );
  };

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  return (
    <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
      {/* Sidebar - Desktop */}
      <Box
        sx={{
          width: { xs: '100%', md: '300px' },
          backgroundColor: '#e5ddd5',
          borderRight: '1px solid #ccc',
          display: { xs: 'none', md: 'flex' },
          flexDirection: 'column',
          p: 2,
          boxShadow: '2px 0 5px rgba(0,0,0,0.05)',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <Tooltip title="Back to Dashboard">
            <IconButton
              onClick={handleRedirectToDashboard}
              sx={{
                color: '#075E54',
                '&:hover': { backgroundColor: 'rgba(7, 94, 84, 0.15)' },
              }}
            >
              <AccountCircleIcon sx={{ fontSize: 28 }} />
            </IconButton>
          </Tooltip>
          <Typography variant="h6" sx={{ color: '#075E54', fontWeight: 600 }}>
            All Users
          </Typography>
        </Box>

        <TextField
          placeholder="Search by name"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={handleSearch}
          sx={{
            mb: 2,
            '& .MuiOutlinedInput-root': {
              backgroundColor: '#fff',
              borderRadius: '20px',
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: '#075E54' }} />
              </InputAdornment>
            ),
          }}
        />

        <List
          sx={{
            overflowY: 'auto',
            flex: 1,
            '&::-webkit-scrollbar': { width: '6px' },
            '&::-webkit-scrollbar-thumb': { backgroundColor: '#b2dfdb', borderRadius: '8px' },
          }}
        >
          {filteredUsers.map((user) => (
            <ListItem
              button
              key={user.id}
              onClick={() => handleUserClick(user)}
              sx={{
                borderRadius: 2,
                mb: 1,
                '&:hover': { backgroundColor: '#d0f0e8' },
              }}
            >
              <ListItemAvatar>
                <Badge
                  variant="dot"
                  color="success"
                  overlap="circular"
                  invisible={!user.is_online}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                >
                  <Avatar
                    src={user.profile_image}
                    sx={{ border: user.is_online ? '2px solid #25D366' : 'none' }}
                  />
                </Badge>
              </ListItemAvatar>
              <ListItemText
                primary={<Typography fontWeight="600" sx={{ color: '#202c33' }}>{user.username}</Typography>}
                secondary={
                  <>
                    <Typography variant="body2" color="#546e7a">
                      {user.role}
                    </Typography>
                    {user.is_online ? (
                      <Typography variant="caption" sx={{ color: '#25d366', display: 'flex', alignItems: 'center' }}>
                        <CircleIcon sx={{ fontSize: 10, mr: 0.5 }} /> Active now
                      </Typography>
                    ) : (
                      user.last_seen_display && (
                        <Typography variant="caption" color="#839496">
                          {user.last_seen_display}
                        </Typography>
                      )
                    )}
                  </>
                }
              />
            </ListItem>
          ))}
        </List>
      </Box>

      {/* Drawer - Mobile Sidebar */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        sx={{
          '& .MuiDrawer-paper': {
            width: '300px',
            backgroundColor: '#e5ddd5',
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <Tooltip title="Back to Dashboard">
              <IconButton
                onClick={handleRedirectToDashboard}
                sx={{
                  color: '#075E54',
                  '&:hover': { backgroundColor: 'rgba(7, 94, 84, 0.15)' },
                }}
              >
                <AccountCircleIcon sx={{ fontSize: 28 }} />
              </IconButton>
            </Tooltip>
            <Typography variant="h6" sx={{ color: '#075E54', fontWeight: 600 }}>
              All Users
            </Typography>
          </Box>

          <TextField
            placeholder="Search by name"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={handleSearch}
            sx={{
              mb: 2,
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#fff',
                borderRadius: '20px',
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: '#075E54' }} />
                </InputAdornment>
              ),
            }}
          />

          <List
            sx={{
              overflowY: 'auto',
              maxHeight: '70vh',
              '&::-webkit-scrollbar': {
                width: '6px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#b2dfdb',
                borderRadius: '8px',
              },
            }}
          >
            {filteredUsers.map((user) => (
              <ListItem
                button
                key={user.id}
                onClick={() => handleUserClick(user)}
                sx={{
                  borderRadius: 2,
                  mb: 1,
                  '&:hover': { backgroundColor: '#d0f0e8' },
                }}
              >
                <ListItemAvatar>
                  <Badge
                    variant="dot"
                    color="success"
                    overlap="circular"
                    invisible={!user.is_online}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  >
                    <Avatar
                      src={user.profile_image}
                      sx={{ border: user.is_online ? '2px solid #25D366' : 'none' }}
                    />
                  </Badge>
                </ListItemAvatar>
                <ListItemText
                  primary={<Typography fontWeight="600" sx={{ color: '#202c33' }}>{user.username}</Typography>}
                  secondary={
                    <>
                      <Typography variant="body2" color="#546e7a">
                        {user.role}
                      </Typography>
                      {user.is_online ? (
                        <Typography variant="caption" sx={{ color: '#25d366', display: 'flex', alignItems: 'center' }}>
                          <CircleIcon sx={{ fontSize: 10, mr: 0.5 }} /> Active now
                        </Typography>
                      ) : (
                        user.last_seen_display && (
                          <Typography variant="caption" color="#839496">
                            {user.last_seen_display}
                          </Typography>
                        )
                      )}
                    </>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>

      {/* Chat Panel */}
<Box
  sx={{
    flex: 1,
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    background: "#efeae2",
    position: "relative",
    overflow: "hidden",
  }}
>

  {/* HEADER */}
  <Box
    sx={{
      height: 70,
      px: 3,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      background:
        "linear-gradient(135deg,#075E54,#128C7E)",
      color: "white",
      boxShadow: "0 4px 15px rgba(0,0,0,.15)",
      zIndex: 2,
    }}
  >

    <Box>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          letterSpacing: .3,
        }}
      >
        {selectedUser
          ? `Chat with ${selectedUser.username}`
          : "School Members Chat"}
      </Typography>

      <Typography
        variant="caption"
        sx={{
          opacity:.8,
        }}
      >
        Online communication portal
      </Typography>

    </Box>


    <IconButton
      onClick={() => setDrawerOpen(!drawerOpen)}
      sx={{
        display:{
          xs:"flex",
          md:"none"
        },
        color:"white",
        background:"rgba(255,255,255,.15)",
      }}
    >
      <MenuIcon/>
    </IconButton>


  </Box>



  {/* CHAT AREA */}
<Box
  sx={{
    flex: 1,
    overflowY: "auto",
    px: {
      xs: 1,
      md: 4,
    },
    py: 3,

    backgroundImage: `
      linear-gradient(
        rgba(255,255,255,.75),
        rgba(255,255,255,.75)
      ),
      url(${chatWallpaper})
    `,

    backgroundSize: "cover",
    backgroundPosition: "center",

    display: "flex",
    flexDirection: "column",
    gap: 1.5,
  }}
>


{
chatHistory.map((chat,index)=>{

const senderId = chat.sender
? (
typeof chat.sender==="object"
? chat.sender.id
: parseInt(chat.sender)
)
:null;


const isSender =
parseInt(currentUserId)===senderId;


const senderUser =
users.find((u)=>u.id===senderId);


const avatarSrc =
chat.sender_profile_image ||
(senderUser ? senderUser.profile_image:null);



return (

<Box
key={chat.id || index}
sx={{
display:"flex",
alignItems:"flex-end",
justifyContent:
isSender
?"flex-end"
:"flex-start",
gap:1,
}}
>


{
!isSender &&
<Avatar
src={avatarSrc}
sx={{
width:38,
height:38,
boxShadow:
"0 3px 8px rgba(0,0,0,.15)"
}}
/>
}



<Box
sx={{
maxWidth:{
xs:"85%",
md:"65%"
},

background:
isSender
?
"linear-gradient(135deg,#dcf8c6,#c8f7a8)"
:
"white",


borderRadius:
isSender
?
"18px 18px 4px 18px"
:
"18px 18px 18px 4px",


px:2,
py:1.2,

boxShadow:
"0 3px 10px rgba(0,0,0,.12)",

position:"relative",

}}

>


<Typography
sx={{
fontSize:15,
color:"#222",
whiteSpace:"pre-wrap",
lineHeight:1.5,
}}
>
{chat.message}
</Typography>



{
chat.image &&

<img
src={chat.image}
alt="chat attachment"

style={{
width:"100%",
maxWidth:250,
maxHeight:250,
objectFit:"cover",
borderRadius:15,
marginTop:10,
cursor:"pointer",
}}
/>

}



<Typography
variant="caption"
sx={{
display:"block",
textAlign:"right",
fontSize:10,
color:"#777",
mt:.5,
}}
>
{
new Date(chat.timestamp)
.toLocaleTimeString(
[],
{
hour:"2-digit",
minute:"2-digit"
}
)
}
</Typography>


</Box>






{
isSender &&
<Avatar
src={avatarSrc}
sx={{
width:38,
height:38,
boxShadow:
"0 3px 8px rgba(0,0,0,.15)"
}}
/>
}



</Box>

)

})
}



{
isTyping &&
<Typography
variant="caption"
sx={{
ml:2,
color:"#666",
fontStyle:"italic"
}}
>
Typing...
</Typography>
}



<div ref={chatEndRef}/>


</Box>





{/* MESSAGE INPUT */}

<Box
sx={{
p:2,
display:"flex",
gap:1.5,
alignItems:"center",

background:
"rgba(255,255,255,.95)",

borderTop:
"1px solid #ddd",

backdropFilter:
"blur(10px)",

}}

>


<TextField

fullWidth

placeholder="Type a message"

value={message}

onChange={(e)=>{
setMessage(e.target.value);
handleTyping();
}}

onKeyDown={(e)=>{
if(e.key==="Enter" && !e.shiftKey){
e.preventDefault();
handleSendMessage();
}
}}


multiline

maxRows={4}


sx={{

"& .MuiOutlinedInput-root":{

borderRadius:30,

background:"#f5f5f5",

px:2,

},

}}

 />



<input
type="file"
accept="image/*"
onChange={handleImageChange}
style={{
display:"none"
}}
id="image-upload"
/>


<label htmlFor="image-upload">


<Button

component="span"

sx={{

minWidth:50,

width:50,

height:50,

borderRadius:"50%",

background:"#fff",

color:"#128C7E",

boxShadow:
"0 4px 12px rgba(0,0,0,.15)"

}}

>

<ImageIcon/>

</Button>


</label>




<Button

onClick={handleSendMessage}

disabled={!message.trim() && !image}

sx={{

minWidth:52,

width:52,

height:52,

borderRadius:"50%",

background:
"linear-gradient(135deg,#25D366,#128C7E)",

color:"white",

boxShadow:
"0 5px 15px rgba(18,140,126,.4)",


"&:hover":{
background:
"linear-gradient(135deg,#128C7E,#075E54)"
},

"&:disabled":{
background:"#ccc"
}

}}

>

<SendIcon/>

</Button>



</Box>



</Box>
    </Box>
  );
};

export default ChatApp;
